import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
} from "@fluentui/react-components";

export const columnSizingOptionsRenewalErrors = {
  companyGuid: { minWidth: 120, defaultWidth: 200 },
  companyName: { minWidth: 150, defaultWidth: 260 },
  email: { minWidth: 150, defaultWidth: 260 },
  phone: { minWidth: 120, defaultWidth: 160 },
  contactName: { minWidth: 120, defaultWidth: 180 },
  errorReason: { minWidth: 200, defaultWidth: 360 },
  errorCode: { minWidth: 80, defaultWidth: 120 },
};

export type RenewalErrorItem = {
  companyGuid?: string | null;
  companyName?: string | null;
  email?: string | null;
  phone?: string | null;
  contactName?: string | null;
  errorReason?: string | null;
  errorCode?: string | null;
};

export const getColumnsRenewalErrors = (theme: Theme) =>
  [
    createTableColumn<RenewalErrorItem>({
      columnId: "companyGuid",
      renderHeaderCell: () => "Fiók ID",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.companyGuid ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) =>
        `${a.companyGuid ?? ""}`.localeCompare(`${b.companyGuid ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "companyName",
      renderHeaderCell: () => "Cég név",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.companyName ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) =>
        `${a.companyName ?? ""}`.localeCompare(`${b.companyName ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "email",
      renderHeaderCell: () => "Email",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.email ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) => `${a.email ?? ""}`.localeCompare(`${b.email ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "phone",
      renderHeaderCell: () => "Telefon",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.phone ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) => `${a.phone ?? ""}`.localeCompare(`${b.phone ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "contactName",
      renderHeaderCell: () => "Kapcsolattartó",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.contactName ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) =>
        `${a.contactName ?? ""}`.localeCompare(`${b.contactName ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "errorReason",
      renderHeaderCell: () => "Hiba oka",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.errorReason ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) =>
        `${a.errorReason ?? ""}`.localeCompare(`${b.errorReason ?? ""}`),
    }),

    createTableColumn<RenewalErrorItem>({
      columnId: "errorCode",
      renderHeaderCell: () => "Hiba kód",
      renderCell: (item) => (
        <TableCellLayout truncate>{item.errorCode ?? "-"}</TableCellLayout>
      ),
      compare: (a, b) =>
        `${a.errorCode ?? ""}`.localeCompare(`${b.errorCode ?? ""}`),
    }),
  ] as TableColumnDefinition<RenewalErrorItem>[];
